import axios, { AxiosResponse } from 'axios';

import apiPaths from 'enums/apiPaths';

export interface ICaptcha {
    id: number;
    image: string;
}

const captcha = async (): Promise<ICaptcha> => {
    const { data }: AxiosResponse<ICaptcha> = await axios({
        method: 'GET',
        url: apiPaths.CAPTCHA
    });
    data.image = `data:image/png;base64,${data.image}`;

    return data;
};

export default captcha;
